import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
  TreeSelectionsReducer,
} from './common.js';

const MatchSelectionsReducer = TreeSelectionsReducer;

const MatchSelectionsAggregator = ({ responses }) =>
  (responses || []).reduce((acc, response) => {
    const { data } = response || {};
    const { answers } = data || {};
    const rowsIds = Object.keys(answers || {}) || [];

    if (!rowsIds.length) return acc;

    (Object.keys(answers) || []).forEach(rowId => {
      const rowAnswers = answers[rowId];

      if (!rowAnswers) return;

      if (!acc[rowId]) {
        acc[rowId] = [];
      }

      (rowAnswers || []).forEach((rowAnswer, index) => {
        if (!acc[rowId][index]) {
          acc[rowId].push({ count: 0, value: true });
        }

        if (rowAnswer) {
          acc[rowId][index].count += 1;
        }
      });
    });

    return acc;
  }, {});

export default {
  AggregateMap: GlobalAggregateMap(MatchSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(MatchSelectionsReducer),
};
